__turbopack_context__.v({
  "accordionPanel": "styles-module__eQdwoq__accordionPanel",
  "accordionWrapper": "styles-module__eQdwoq__accordionWrapper",
  "accordionWrapper--empty": "styles-module__eQdwoq__accordionWrapper--empty",
  "emptyState": "styles-module__eQdwoq__emptyState",
  "orderSummaryPanel": "styles-module__eQdwoq__orderSummaryPanel",
  "panel": "styles-module__eQdwoq__panel",
  "skeletonAccordionRow": "styles-module__eQdwoq__skeletonAccordionRow",
  "skeletonAccordionTitle": "styles-module__eQdwoq__skeletonAccordionTitle",
  "skeletonPanelContent": "styles-module__eQdwoq__skeletonPanelContent",
  "skeletonSellerRow": "styles-module__eQdwoq__skeletonSellerRow",
  "title": "styles-module__eQdwoq__title",
});
